document.addEventListener('change', function(e) {
    // Kolla om det som ändrades var en radioknapp
    if (e.target && e.target.type === 'radio') {

        const label = e.target.nextElementSibling;
        if (!label) return;

        const hiddenData = label.querySelector('.hidden-package-data');

        if (hiddenData) {
            // Hämta data
            const titleHTML = hiddenData.querySelector('.pkg-title').innerHTML;
            const descHTML  = hiddenData.querySelector('.pkg-desc').innerHTML;
            const listHTML  = hiddenData.querySelector('.pkg-list').innerHTML;

            // Målelementen
            const titleEl = document.getElementById('dpd-title');
            const descEl  = document.getElementById('dpd-desc');
            const listEl  = document.getElementById('dpd-list');
            const detailsBox = document.getElementById('dynamic-package-details');
            const listWrapper = document.getElementById('dpd-list-wrapper'); // <- Vårt nya ID

            if (titleEl && descEl && listEl && detailsBox) {
                // Skriv in all text
                titleEl.innerHTML = titleHTML;
                descEl.innerHTML = descHTML;
                listEl.innerHTML = listHTML;

                // Logiken för att dölja "Detta ingår" om listan är tom
                if (listHTML.trim() === '') {
                    listWrapper.style.display = 'none'; // Gömmer rutan om den är tom
                } else {
                    listWrapper.style.display = 'block'; // Visar rutan om det finns listpunkter
                }

                // Visa den stora moderrutan
                detailsBox.classList.remove('hidden');
                detailsBox.style.display = 'block';
            }
        }
    }
});

// Gravity Forms specifika event för när formuläret har renderats via AJAX.
// 'gform/postRender' är GF:s egna, jQuery-fria motsvarighet till
// 'gform_post_render' -- ett riktigt CustomEvent dispatchat på document
// (se gform.utils.trigger i assets/js/dist/utils.min.js), inte bara ett
// jQuery-internt event.
document.addEventListener('gform/postRender', function () {
    const preSelected = document.querySelector('input[type="radio"]:checked');
    if (preSelected && preSelected.nextElementSibling.querySelector('.hidden-package-data')) {
        preSelected.dispatchEvent(new Event('change', { bubbles: true }));
    }
});